import React from "react";
import ReactDOM, {createRoot} from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {ThemeProvider} from "@emotion/react";
import {CssBaseline} from "@mui/material";
import {theme} from "./theme";
import initLocalization from "admin/src/i18n";
import App from "./App";


// REQUIRES yarn serve -l 3005 -s packages/booking-engine-widget/dist in order to work

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient()

const initApp = async () => {
    await initLocalization()
    root.render(
        <React.StrictMode>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <ThemeProvider theme={theme}>
                        <CssBaseline/>
                        <App/>
                    </ThemeProvider>
                </BrowserRouter>
            </QueryClientProvider>
        </React.StrictMode>
    )
}

initApp()


